import { DatePipe, UpperCasePipe } from '@angular/common';
import {
  Component,
  effect,
  Inject,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import {
  WHDomEvent,
  WHDropdownModule,
  WHIconENUM,
} from '@workheld/workheld-shared-lib';
import { isFuture, subMinutes } from 'date-fns';
import { RemindTechnicianService } from 'src/app/app-services/remind-technician.service';
import { UIService } from 'src/app/app-services/ui.service';
import { WHButtonComponent } from 'src/app/app-shared/components/buttons/w-h-button/w-h-button.component';
import { WHButtonGroupComponent } from 'src/app/app-shared/components/buttons/w-h-button-group/w-h-button-group.component';

@Component({
  selector: 'app-mat-dialog-remind-technician-settings',
  imports: [
    MatIconModule,
    TranslateModule,
    WHDropdownModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    UpperCasePipe,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    DatePipe,
    WHButtonComponent,
    WHButtonGroupComponent,
  ],
  templateUrl: './mat-dialog-remind-technician-settings.component.html',
  styleUrl: './mat-dialog-remind-technician-settings.component.scss',
})
export class MatDialogRemindTechnicianSettingsComponent implements OnInit {
  remindTechnicianFormGroup = new FormGroup({
    reminderOffsetInMinutes: new FormControl(null, Validators.required),
    reminderComment: new FormControl(''),
  });
  private remindTechnicianService = inject(RemindTechnicianService);
  alertOptions = this.remindTechnicianService.alertOptions();

  notificationTime = signal('');
  currentLocale: string;

  constructor(
    uiService: UIService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      scheduledStartDate: string;
      calculatedWorkOrderStatusId: number;
      reminderComment: string;
      reminderOffsetInMinutes: number;
      hideDeleteButton: boolean;
      bulkAction: boolean;
      showNoneMessage: boolean;
    },
  ) {
    effect(() => {
      let alertOptions = this.remindTechnicianService.alertOptions();

      if (data.scheduledStartDate) {
        alertOptions = alertOptions.filter((option) =>
          isFuture(subMinutes(new Date(data.scheduledStartDate), option.value)),
        );
      }
      this.alertOptions = alertOptions;
    });

    effect(() => {
      this.currentLocale = uiService.$currentLocale();
    });

    this.remindTechnicianFormGroup.patchValue({
      reminderOffsetInMinutes: data.reminderOffsetInMinutes,
      reminderComment: data.reminderComment,
    });

    if (this.data.reminderOffsetInMinutes) {
      this.setNotificationTime({
        type: 'optionSelected',
        payload: data.reminderOffsetInMinutes,
      });
    }
  }
  ngOnInit(): void {}

  setNotificationTime(event: WHDomEvent) {
    if (event && event.type === 'optionSelected') {
      const newDate = subMinutes(
        new Date(this.data.scheduledStartDate),
        event.payload,
      );
      this.notificationTime.set(newDate.toString());
    } else if (event && event.type === 'onResetValue') {
      this.notificationTime.set('');
    }
  }

  get notificationTimeFormatted(): string {
    if (this.notificationTime()) {
      return this.notificationTime();
    }
    return null;
  }

  public get saveIcon(): string {
    return WHIconENUM.SaveIcon as string;
  }

  public get cancelIcon(): string {
    return WHIconENUM.CancelIcon as string;
  }

  public get deleteIcon(): string {
    return WHIconENUM.DeleteIcon as string;
  }
}
